// QR 케이스 토큰 (기획서_QR공정체크 §5-4) — 불투명 토큰, 환자정보 미포함 원칙
// 문서 id = 토큰 문자열(22자 base64url). 내용: { v, labId, target:{origin,id}, createdAt, expiresAt(30일), ... }
// ★ 이 문서에 환자 이름·치과 이름을 절대 넣지 않는다 — QR이 유출돼도 토큰만으로는 아무것도 못 읽는다
//   (해석은 로그인한 그 기공소 계정만 가능 — rules + 대상 문서 자체의 읽기 권한).
import { collection, query, where, getDocs, doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

const TOKEN_TTL_DAYS = 30;   // 대표 확정 2026-08-09: QR 만료 30일 (인쇄물 재출력 없이 재발급되도록 조회 시 자동 갱신)

const randomToken = () => {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    let bin = '';
    bytes.forEach(b => { bin += String.fromCharCode(b); });
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');   // base64url 22자
};

/**
 * getOrCreateToken(labId, target) — target = { origin:'order'|'case', id }
 * 같은 대상의 유효 토큰이 있으면 재사용, 없으면 새로 만든다. 실패하면 null (예외를 밖으로 던지지 않는다).
 */
export async function getOrCreateToken(labId, target) {
    try {
        if (!labId || !target || !target.id || !['order', 'case'].includes(target.origin)) return null;
        const snap = await getDocs(query(
            collection(db, 'caseTokens'),
            where('labId', '==', labId),
            where('target.origin', '==', target.origin),
            where('target.id', '==', target.id),
        ));
        const now = Date.now();
        const alive = snap.docs.find(d => {
            const x = d.data();
            if (x.revokedAt) return false;
            const exp = x.expiresAt && (typeof x.expiresAt.toDate === 'function' ? x.expiresAt.toDate() : new Date(x.expiresAt));
            return !exp || exp.getTime() > now;
        });
        if (alive) return alive.id;
        const token = randomToken();
        await setDoc(doc(db, 'caseTokens', token), {
            v: 1,
            labId,
            target: { origin: target.origin, id: target.id },
            createdAt: new Date(),
            expiresAt: new Date(now + TOKEN_TTL_DAYS * 86400000),
            revokedAt: null,
            printedCount: 0,
        });
        return token;
    } catch (e) {
        console.error('caseToken.getOrCreateToken 실패:', e?.code || e?.message || e);   // 환자정보 없음
        return null;
    }
}

export const tokenUrl = (token) => `${window.location.origin}/q/${token}`;
